import React from "react";
import { NavItem, NavLink, Badge, Collapse, DropdownItem } from "shards-react";

export default class Notifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };

    this.toggleNotifications = this.toggleNotifications.bind(this);
  }

  componentDidMount() {
    fetch("https://data.covid19india.org/data.json")
    .then((res) => res.json())
    .then((data) => {
      // console.log("Fetched state wise data:", data.statewise, data.key_values, data.cases_time_series);
      this.setState({
        confirmed: data.statewise[0].deltaconfirmed,
        recovered: data.statewise[0].deltarecovered,
        deaths: data.statewise[0].deltadeaths
      })
    })
    .catch(console.log);
  }

  toggleNotifications() {
    this.setState({
      visible: !this.state.visible
    });
  }

  render() {
    return (
      <NavItem className="border-right dropdown notifications">
        <NavLink
          className="nav-link-icon text-center"
          onClick={this.toggleNotifications}
        >
          <div className="nav-link-icon__wrapper">
            <i className="material-icons">&#xE7F4;</i>
            <Badge pill theme="danger">
              3
            </Badge>
          </div>
        </NavLink>
        <Collapse
          open={this.state.visible}
          className="dropdown-menu dropdown-menu-small"
        >
          <DropdownItem>
            <div className="notification__icon-wrapper">
              <div className="notification__icon">
                <i className="material-icons">&#xE6E1;</i>
              </div>
            </div>
            <div className="notification__content">
              <span className="notification__category">Today's Report</span>
              <p>
                Today, the number of confirmed cases are {" "}
                <span className="text-primary text-semibold">{this.state.confirmed}</span>, number of recovered cases are <span className="text-success text-semibold">{this.state.recovered}</span>, and {" "}
                number of deaths are <span className="text-danger text-semibold">{this.state.deaths}</span>.
              </p>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className="notification__icon-wrapper">
              <div className="notification__icon">
                <i className="material-icons">mood</i>
              </div>
            </div>
            <div className="notification__content">
              <span className="notification__category">PM Cares Fund</span>
              <p>
               Please donate to the <a href="https://pib.gov.in/PressReleseDetailm.aspx?PRID=1608851" target="_blank">PM Cares Fund</a> and practice social distancing. 
              </p>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className="notification__icon-wrapper">
              <div className="notification__icon">
                <i className="material-icons">share</i>
              </div>
            </div>
            <div className="notification__content">
              <span className="notification__category">Support Me</span>
              <p>
               Thank you for visiting this website. Please show some love by starring <a href="https://github.com/vinitshahdeo/COVID19">this</a> repository. You can checkout the old website <a href="https://corona-cases-india.netlify.app/">here</a>.
              </p>
            </div>
          </DropdownItem>
          <DropdownItem className="notification__all text-center">
          <span className="notification__category">Stay Home, Stay Safe!</span>
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
